import React from "react";
import {
    ResponsiveContainer,
    LineChart,
    Line,
    CartesianGrid,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
} from "recharts";
import { SectionCard } from "../scraper";

const CustomTooltip = ({ active, payload, label }) => {
    if (!active || !payload?.length) return null;
    return (
        <div className="bg-white border border-gray-100 rounded-lg shadow-md px-3 py-2 text-xs">
            <p className="text-gray-500 mb-1 font-medium">{label}</p>
            {payload.map((p) => (
                <div key={p.name} className="flex items-center gap-2">
                    <span
                        className="inline-block w-2 h-2 rounded-full"
                        style={{ background: p.color }}
                    />
                    <span className="text-gray-700">
                        {p.name}: <strong>{p.value}</strong>
                    </span>
                </div>
            ))}
        </div>
    );
};

const CampaignTrendChart = ({ data = [] }) => {
    const formattedData = data.map((item) => ({
        ...item,
        date: new Date(item.date).toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
        }),
    }));

    return (
        <SectionCard title="Campaign Trend">
            <div className="h-72">
                <ResponsiveContainer width="100%" height="100%">
                    <LineChart
                        data={formattedData}
                        margin={{ top: 4, right: 8, left: -16, bottom: 0 }}
                    >
                        <CartesianGrid
                            strokeDasharray="3 3"
                            stroke="#f0f0f0"
                            vertical={false}
                        />
                        <XAxis
                            dataKey="date"
                            tick={{ fontSize: 11, fill: "#9ca3af" }}
                            axisLine={false}
                            tickLine={false}
                        />
                        <YAxis
                            tick={{ fontSize: 11, fill: "#9ca3af" }}
                            axisLine={false}
                            tickLine={false}
                        />
                        <Tooltip content={<CustomTooltip />} />
                        <Legend
                            wrapperStyle={{ fontSize: 12, paddingTop: 12 }}
                        />
                        <Line
                            type="monotone"
                            dataKey="campaigns"
                            stroke="#3b82f6"
                            strokeWidth={2.5}
                            dot={{ r: 3, fill: "#3b82f6", strokeWidth: 0 }}
                            activeDot={{ r: 5 }}
                            name="Campaigns"
                        />
                        <Line
                            type="monotone"
                            dataKey="emails"
                            stroke="#10b981"
                            strokeWidth={2.5}
                            dot={{ r: 3, fill: "#10b981", strokeWidth: 0 }}
                            activeDot={{ r: 5 }}
                            name="Emails"
                        />
                    </LineChart>
                </ResponsiveContainer>
            </div>
        </SectionCard>
    );
};

export default CampaignTrendChart;